module.exports = __webpack_public_path__ + "img/80h100_gluhoe.477d78cf.svg";